import { modalHabitat as Component } from './modal';
export default Component;
